import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import ColumnLayoutViewModel from '@/ViewModels/Controls/ColumnLayoutViewModel';

export default class EmbeddedGroupLayoutViewModel extends ControlViewModel {
    private ColumnLayoutViewModel = ComponentManager.getViewModel<typeof ColumnLayoutViewModel>('ColumnLayoutViewModel');

    /**
     * Die Factory-Tuples
     */
    public tuples: Array<any>;

    /**
     * Beinhaltet und verändert die Breite der LabelColumn
     */
    public labelColumnWidth: KnockoutObservable<number>;

    /**
     * Das innere ColumnLayout
     */
    public columnLayout: ColumnLayoutViewModel;

    /**
     * Das ViewModel für die EmbeddedGroupLayoutViewModel
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.tuples = this.paramOrDefault(params.tuples, []);
        this.labelColumnWidth = this.observableOrDefault(params.labelColumnWidth, 200);
        this.columnLayout = new this.ColumnLayoutViewModel({
            columnsPerRow: 1,
            labelColumnWidth: this.labelColumnWidth,
            tuples: this.tuples
        });

        ControlViewModel.checkProperties(this, params);
    }
}

ComponentManager.setViewModel('EmbeddedGroupLayoutViewModel', EmbeddedGroupLayoutViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');